const CreditCardUsageType = {
  ServiceFees: 90,
  FlightSeats: 91,
  Insurance: 92,
};

export default CreditCardUsageType;
